export default __webpack_public_path__ + "static/media/oj_miodku.207cab42.svg";